import { render, staticRenderFns } from "./gestion_empresa.vue?vue&type=template&id=1bb6ee50&scoped=true"
import script from "./gestion_empresa.vue?vue&type=script&lang=js"
export * from "./gestion_empresa.vue?vue&type=script&lang=js"
import style0 from "./gestion_empresa.vue?vue&type=style&index=0&id=1bb6ee50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb6ee50",
  null
  
)

export default component.exports